<app-navigation></app-navigation>
<!-- <app-header></app-header> -->
<router-outlet></router-outlet>
<app-footer></app-footer>
<ngx-spinner type = "line-scale-party" [fullScreen] = "true">
    <p style="color: white" > Loading... </p>
</ngx-spinner>